/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popFaceScan.vue?vue&type=template&id=54769d56&scoped=true"
import script from "./popFaceScan.vue?vue&type=script&lang=js"
export * from "./popFaceScan.vue?vue&type=script&lang=js"
import style0 from "./popFaceScan.vue?vue&type=style&index=0&id=54769d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54769d56",
  null
  
)

export default component.exports